import React from "react";
import FormSelect from "../FormSelect";
import { useFetchClientAccountDetailsListQuery } from "../../../services/clientdetails";

const ClientAccountSelect = ({ options, masterAccountId, ...rest }) => {
    const { data, error, isError, isLoading, isFetching } = useFetchClientAccountDetailsListQuery({ masterAccountId });
    return <FormSelect
        options={data}
        isLoadingOptions={isLoading || isFetching}
        {...rest}
    />
};

export default ClientAccountSelect;